<template>

  <v-app id="squiddy">

    <v-navigation-drawer
      clipped
      fixed
      v-model="drawer"
      app
      permanent
      mini-variant
    >
      <v-list dense>
        <v-list-item :to="{ name: 'projects', params: { accountId: accountId } }" exact>
          <v-list-item-action>
            <v-icon>mdi-select-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Projects</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app fixed clipped-left dark color="#00182f">
      <img height="25" class="mx-5" src="@/assets/logo-white.svg" />
      <v-toolbar-title>Squiddy</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu
        v-model="menu"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-toolbar-items>
            <v-btn text v-on="on">
              {{ account.name }}
              <v-icon right>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar-items>
        </template>

        <v-card>
          <v-list>
            <v-list-item>

              <v-list-item-content>
                <v-list-item-title class="text-uppercase">{{ account.name }}</v-list-item-title>
                <v-list-item-subtitle>#{{ account.id }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  icon
                  @click="logout"
                >
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </v-list-item-action>

            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item :to="{ name: 'connections' }">
              <v-list-item-icon>
                <v-icon>mdi-google-ads</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Google Ads integration</v-list-item-title>
            </v-list-item>
          </v-list>

        </v-card>
      </v-menu>

    </v-app-bar>
    <v-main>
      <v-container fluid class="pa-10">
        <router-view/>
      </v-container>
    </v-main>
    <v-footer app fixed height="40" inset>
      <div class="footer-content">
        <span>&copy; 2019 <v-icon small>mdi-code-tags</v-icon> with <v-icon small>mdi-coffee</v-icon> by Invoke</span>
      </div>
    </v-footer>

  </v-app>

</template>

<script>

export default {
  components: {},
  props: ['accountId'],
  data: () => ({
    drawer: null,
    menu: false
  }),
  mounted () {
    this.$store.dispatch('getUser')
  },

  computed: {

    account () {
      return (this.user.accounts || [])[0] || {}
    },

    user () {
      return this.$store.state.user || {}
    },

  },
  methods: {
    logout () {
      this.$store.dispatch('LOGOUT').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
